export const Divider = () => {
  return (
    <div style={{ width: "100%", height: "1px", backgroundColor: "#dcdddc" }} />
  );
};
